import React, { useContext, useEffect, useState } from 'react'
import { formatDate, ROUTES } from '../../../shared/constants'
import { useHistory } from 'react-router'
import { useTrainingCategory } from '../../../hooks/Others/LearningAndDevelopment/useTrainingCategory'
import { OtherContext } from '../../../context api/Others/OtherContext'
import { useDownload } from '../../../hooks/Download/useDownload'
import CustomTableLayout from '../../../components/CustomComponents/CustomTableLayout'

export default function TrainingCategory() {
  const { getAllTrainingCategories, deleteManyTrainingCategory, loading, paginate, updateTrainingCategory } = useTrainingCategory()
  const { downloadLoading, getPdfCsvData, pdfCsvData } = useDownload()
  const { trainingCategories } = useContext(OtherContext)
  //console.log('trainingCategories : ', trainingCategories)
  const history = useHistory()

  const [searchQuery, setSearchQuery] = useState('')
  const filterTrainingCategory = trainingCategories
  const [page, setPage] = React.useState(1)

  const noOfPages = paginate && paginate.totalPage
  useEffect(() => {
    getAllTrainingCategories({
      page: page,
      limit: 10,
      searchQuery,
    })
  }, [page, searchQuery])

  useEffect(() => {
    getPdfCsvData('GET_ALL_TRAININGCATEGORY')
  }, [])

  const handleChange = (event, value) => setPage(value)

  const handleSwitchChange = (item) => updateTrainingCategory({ ...item, active: !item.active, trainingCategoryId: item._id })

  let tableBody = []

  if (!loading && filterTrainingCategory.length > 0) {
    tableBody = filterTrainingCategory.map((item) => {
      return [
        { type: 'CHECKBOX', _id: item._id },
        { image: item.image, type: 'IMAGE' },
        { value: item.trainingCategoryCode },
        { value: item.name },
        { value: item.minimumPercentage + ' %' },
        { value: item.retestFrequency + ' Days' },
        { value: item.description },
        { value: formatDate(item.createdAt) },
        { type: 'STATUS', ...item },
        { type: 'INFO', onClick: () => history.push(`/view-training-category/${item._id}`) },
      ]
    })
  }

  const layoutProps = {
    heading: 'Manage Training Categories',
    url: ROUTES.ADD_TRAININGCATEGORY,
    editUrl: `/edit-training-category/`,
    searchQuery: searchQuery,
    setSearchQuery: setSearchQuery,
    tempHeaderData: [],
    filename: 'trainingCategories',
    headers: pdfCsvData.headings,
    data: pdfCsvData.headingValues,
    downloadLoading,
    permissionName: 'LEARNING',
  }

  return (
    <CustomTableLayout
      tableHeadings={['Image', 'Training Category Code', 'Name', 'minimum percentage', 'retest frequency', 'description', 'Created Date', 'Status', 'Info']}
      loading={loading}
      tableBody={tableBody}
      handleSwitchChange={handleSwitchChange}
      handlePageChange={handleChange}
      paginate={{ totalPage: noOfPages, page: page }}
      layoutProps={layoutProps}
      checkbox
      deleteMany={(val, setSelected) => deleteManyTrainingCategory({ trainingCategoryId: val }, setSelected)}
    />
  )
}
